import { ETemplateType } from '@/models/dtos/enums/eTemplateType'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export class TemplateMixin extends Vue {
  templateName(type: ETemplateType) {
    let templateName = ''

    switch (type) {
      case ETemplateType.Company:
        templateName = 'Firma'
        break
      case ETemplateType.Warehouse:
        templateName = 'Magazyn'
        break
      default:
        templateName = 'Firma'
    }

    return templateName
  }
}
